import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, ViewChildren, QueryList, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../environments/environment';
import { OpportunityOfferListOutputModel } from '../../../../shared/models/OpportunityOfferListOutputModel';
import { OpportunityOfferOutputModel } from '../../../../shared/models/OpportunityOfferOutputModel';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { DataTablesResponse } from '../../../../shared/models/datatables-response';
import { ValidationService } from '../../../../shared/providers/validation.service';
import { collapseColumns } from '../../../../shared/models/collapseColumns';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';
import { ToastService } from '../../../../shared/providers/toast.service';
import { MultipleEmailIdModel } from '../../../../shared/models/MultipleEmailIdModel';
import { MatSelect, MAT_SELECT_CONFIG } from '@angular/material/select';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-sort-preview',
  templateUrl: './sort-preview.html',
  styleUrls: ['./sort-preview.css'],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'modal-multi-select' },
    },
  ],
})
export class SortPreview implements OnInit {
  @Input() propertyGuid: string;
  @Input() propertyId: number;
  @Input() isFromPortfolio: boolean;
  @Input() isShareReport: boolean;
  @Output() save = new EventEmitter();
  @Output() close = new EventEmitter();
  activePage: number
  removeModalRef: BsModalRef;
  offerList: OpportunityOfferListOutputModel[];
  prospectSortIndex: number;
  prospectSortOrder: string;
  unChangedofferList: OpportunityOfferOutputModel[];
  offers: OpportunityOfferOutputModel[];
  mailIds: MultipleEmailIdModel[];
  keyCode: number[];
  AssociatedBrokers = [];
  user: any;
  selectedColumns = [];
  //defaultTypeText: IMultiSelectTexts = {
  //  defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  }
  tableColumns: collapseColumns[] = [];

  isAdmin: boolean;
  dtOptions = {};
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;

  dtTrigger: Subject<any> = new Subject();
  table: DataTableDirective;
  @ViewChild(MatSelect) matSelect!: MatSelect;

  constructor(private http: HttpClient,
    private _modalService: BsModalService,
    private _loaderService: LoaderService,
    private _authenticationService: AuthenticationService,
    private router: Router, private cdRef: ChangeDetectorRef, private renderer: Renderer2, private overlay: Overlay, private _validationService: ValidationService, private _propertyService: PropertyListingService, private _toastService: ToastService) { }

  ngOnInit() {
    this.user = this._authenticationService.user;
    this.getOfferList();
    this.keyCode = [32, 188, 13];
  }

  ngAfterViewInit() {
    // Listen to the openedChange event of the MatSelect
    this.matSelect.openedChange.subscribe((isOpened) => {
      if (isOpened) {
        this.addClassToOverlayContainer();
      } else {
        this.removeClassFromOverlayContainer();
      }
    });
  }

  private addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container'); // Add custom class
    }
  }

  private removeClassFromOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.removeClass(overlayContainer, 'custom-overlay-container'); // Remove custom class
    }
  }

  getofferPlacedUserRole(role: string) {
    if (role.toLowerCase().includes("principal") && !this._authenticationService.Admin() && !this._authenticationService.SuperAdmin() && !this._authenticationService.Broker()) {
      return "Principal";
    }
    else {
      return role;
    }
  }

  selectedColumnCopy = [];
  private bindDefaultColumns() {
    this.tableColumns.forEach(item => {
      if (item.id != 9 && item.id != 10 && item.id != 11)
        this.selectedColumns.push(item.id);
      this.selectedColumnCopy.push(item.id);
    });
    /* this.cdRef.detectChanges();*/
  }

  CheckColumn(event) {
    if (this.selectedColumnCopy.length == 7 && this.selectedColumns.length == 7) {
      this._toastService.addToast({ title: 'Error', msg: "Please select at least 7 columns", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else if (this.selectedColumnCopy.length == 10 && this.selectedColumns.length == 11) {
      this._toastService.addToast({ title: 'Error', msg: "Please select only 10 columns", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      this.selectedColumns = this.selectedColumnCopy.map(i => i);
    }
    else {
      this.selectedColumnCopy = this.selectedColumns.map(i => i);
    }
  }

  convertUTCDateToLocalOfferDate(OfferDate: Date) {
    var newDate = new Date(OfferDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }

  hideColumn(col: number) {
    if (this.selectedColumns.indexOf(col) > -1) {
      return false; // show
    }
    else {
      return true; // hide
    }
  }

  onClose() {
    this.close.emit();
  }

  onSave(data) {
    this.prospectSortIndex = data.SortColumn;
    this.prospectSortOrder = data.SortOrder;
  }

  generateReport(Id) {
    this._loaderService.display(true);
    const httpHeader = this._validationService.GetAuthHeader();
    let index: number = 0;
    let sortDirection: string = 'asc';

    if (this.unChangedofferList != null && this.unChangedofferList != undefined && this.unChangedofferList.length>0) {
      index = this.unChangedofferList.find(o => o.SortColumn != null).SortColumn;
      sortDirection = this.unChangedofferList.find(o => o.SortOrder != null).SortOrder;
    }
    let shareReportInputModel = {
      OfferIndex: index,
      OfferSortDirection: sortDirection,
      ProspectIndex: this.prospectSortIndex,
      ProspectSortDirection: (this.prospectSortOrder == null || this.prospectSortOrder == undefined) ? 'asc' : this.prospectSortOrder,
      PropertyId: this.propertyId,
      SelectedColumns: this.tableColumns.filter(i => this.selectedColumns.indexOf(i.id) > -1).map(i => i.name)
    }
    this._propertyService.generateReport(shareReportInputModel).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this._validationService.downloadPDFFile('/upload/pdffile/' + filenameWithoutExtension, filenameWithExtension);
      this._loaderService.display(false);
      this.onClose();
    });
  }

  shareReport(Id) {
    if (this.mailIds != undefined && this.mailIds.length > 0) {
      this._loaderService.display(true);
      const httpHeader = this._validationService.GetAuthHeader();
      let index: number = 0;
      let sortDirection: string = 'asc';

      if (this.unChangedofferList != null && this.unChangedofferList != undefined && this.unChangedofferList.length > 0) {
        index = this.unChangedofferList.find(o => o.SortColumn != null).SortColumn;
        sortDirection = this.unChangedofferList.find(o => o.SortOrder != null).SortOrder;
      }
      let shareReportInputModel = {
        OfferIndex: index,
        OfferSortDirection: sortDirection,
        ProspectIndex: this.prospectSortIndex,
        ProspectSortDirection: (this.prospectSortOrder == null || this.prospectSortOrder == undefined) ? 'asc' : this.prospectSortOrder,
        PropertyId: this.propertyId,
        SelectedColumns: this.tableColumns.filter(i => this.selectedColumns.indexOf(i.id) > -1).map(i => i.name),
        UserId: this.user.Id,
        EmailForShare: this.mailIds.map(function (data) { return data.value })
      }
      this._propertyService.shareReport(shareReportInputModel).subscribe(resp => {
        let filenameWithExtension: string = resp.toString();
        let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
        setTimeout(() => {
          this._validationService.deletePdfFile('/upload/deletepdffile/' + filenameWithoutExtension);
        }, 5000);
        this._loaderService.display(false);
        this.mailIds = [];
        this.onClose();
      });
    }
    else {
      this._toastService.addToast({
        title: '',
        msg: 'No Email Address added',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
    }
  }

  validEmail$(control: any) {

    if (control.value != "") {
      let serchfind: boolean;
      const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      serchfind = regexp.test(control.value);
      if (serchfind == false) {
        return {
          'validEmail$': true
        };
      }
    }

    return null;
  }

  public validators = [this.validEmail$];

  public errorMessages = {
    'validEmail$': 'Invalid Email Address'
  };

  dtInstance: any;

  getOfferList() {
    var loggedinUserId = this.user.Id;
    var adminUserId = 0;
    const that = this;

    this.tableColumns = [
      { id: 1, name: 'Offer Placed By' },
      { id: 2, name: 'Buyer Company' },
      { id: 3, name: 'Last Modified User' },
      { id: 4, name: 'Property Or Portfolio' },
      { id: 5, name: 'Offer Date' },
      { id: 6, name: 'Offer Price' },
      { id: 7, name: 'Offer Cap Rate' },
      { id: 8, name: 'Earnest Money Deposit' },
      { id: 9, name: 'DD Period' },
      { id: 10, name: 'HC Period' },
      { id: 11, name: 'Status' }
    ];

    this.bindDefaultColumns();

    let TableColums = [
      { data: 'LeadName' },
      { data: 'BuyerEntity' },
      { data: 'LastModifiedUser' },
      { data: 'PropertyOrPortfolio' },
      { data: 'OfferDate' },
      { data: 'OfferPrice' },
      { data: 'CapRate' },
      { data: 'EarnestMoneyDeposit' },
      { data: 'DueDiligencePeriod' },
      { data: 'ClosingPeriod' },
      { data: 'StatusName' },
      ];

    let order = 5;

    if (this._authenticationService.IsUserRole(this._authenticationService.UserRole.Admin) || this._authenticationService.IsUserRole(this._authenticationService.UserRole.SuperAdmin)) {
      adminUserId = this.user.Id;
      loggedinUserId = 0
      this.isAdmin = true;
    }
    else if (this._authenticationService.IsUserRole(this._authenticationService.UserRole.Principal) || this._authenticationService.IsUserRole(this._authenticationService.UserRole.Principal1031) || this._authenticationService.IsUserRole(this._authenticationService.UserRole.ExternalBroker) || this._authenticationService.IsUserRole(this._authenticationService.UserRole.Broker)) {

      if (this._authenticationService.IsUserRole(this._authenticationService.UserRole.Broker)) {
        order = 4;
      }
    }
    const filter =
    {
      LoggedInUserId: loggedinUserId,
      IsFromPortfolio: this.isFromPortfolio != null ? this.isFromPortfolio : false,
      UserId: adminUserId

    }
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      "pageLength": 50,
      "order": [[order, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        dataTablesParameters.Extra_param = filter;
        const httpHeader = this._validationService.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/opportunity/offersPlaced/' + this.propertyGuid,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {

            this.unChangedofferList = resp.data;
            that.offers = resp.data ? resp.data : [];
            this.AssociatedBrokers = that.offers.length > 0 ? that.offers[0]["AssociatedBrokers"] : null;
            var finalIndex = that.offers.length;
            this.offerList = [];
            that.offerList.push({
              Key: '',
              Values: resp.data,
            });

            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide()
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            $(".paginate_button.first,.paginate_button.last").hide();
          });
      },
      columns: TableColums
    };
  }
}

